var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"convenience-fee"},[_vm._v("*A "+_vm._s(_vm.fee)+"% convenience fee will be added to credit cards and digital wallets. To pay\n  without the fee, consider Zelle, ACH, or Wire Transfer.")])
}
var staticRenderFns = []

export { render, staticRenderFns }